import ArrowUp from '@src/sld/components/ArrowUp/ArrowUp';
import VerticalLine from '@src/sld/components/Line/VerticalLine';
import { ReactElement } from 'react';

function Header(): ReactElement {
  return (
    <>
      <text
        x={690}
        y={60}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        138KV TRANSMISSION LINE
      </text>

      <text
        x={710}
        y={70}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        TO HIDDEN LAKES
      </text>

      <text
        x={720}
        y={80}
        fontSize={8}
        fill='white'
        stroke='white'
        strokeWidth={0.2}
      >
        SUBSTATION
      </text>

      <ArrowUp xCoordinate={740} yCoordinate={90} />

      <VerticalLine
        translateXCoordinate={742.8}
        translateYCoordinate={90}
        length={52}
        color='white'
        width={0.5}
      />

      <circle
        cx={742.8}
        cy={143}
        r={1.5}
        fill='none'
        stroke='white'
        strokeWidth={0.7}
      />
    </>
  );
}

export default Header;
